import styled from "styled-components";
import { COLORS, DARK_THEME_COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const FlowButtonWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  flex-direction: column;
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 100;
`;

export const FlowButtons = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
`;

export const FlowButton = styled.button<{ buttonType?: "cancel" | "primary" }>`
  ${FLEX.FlexCenterCenter};
  border-radius: 20px;
  color: ${COLORS.WHITE};
  padding: 0 10px;
  background-color: ${({ buttonType, theme }) =>
    buttonType === "cancel" ? theme.COLORS.BUTTONS3 : theme.COLORS.BUTTONS2};
  min-width: 40px;
  height: 40px;
  font-size: ${calcRem(14)};
`;

export const AddChart = {
  Container: styled.div`
    position: relative;
  `,
  Overlay: styled.div`
    position: absolute;
    bottom: 100%;
    right: 0;
    width: 260px;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid
      ${({ theme }) =>
        theme.value === "light"
          ? theme.COLORS.LIGHTGRAYBORDER
          : COLORS.SIDEBARBG};
    background-color: ${({ theme }) =>
      theme.value === "light" ? theme.COLORS.SIDEBARBG : COLORS.PRIMARY3};
    color: ${({ theme }) => theme.COLORS.WHITE};
    h1 {
      font-size: ${calcRem(16)};
      font-weight: 500;
      color: ${({ theme }) => theme.COLORS.WHITE};
      margin-bottom: 20px;
    }
    li {
      font-size: ${calcRem(14)};
      ${FLEX.FlexStartCenter};
      gap: 10px;
      color: ${({ theme }) => theme.COLORS.WHITE}95;
      input {
        margin-top: 0;
      }
    }
    ${mediaQuery.isMobile} {
      bottom: 0;
      right: 100%;
      margin-bottom: 0;
      margin-right: 10px;
    }
  `,
  List: styled.ul`
    ${FLEX.FlexStartBetween};
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
  `,
  Buttons: styled.div`
    ${FLEX.FlexCenterCenter};
    gap: 10px;
    width: 100%;
    padding-top: 20px;
    button {
      width: 100%;
    }
    .cancel {
      background: transparent;
      border: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
      &:hover {
        filter: none;
      }
      span {
        color: ${({ theme }) => theme.COLORS.WHITE};
      }
    }
  `,
};
